import { render, staticRenderFns } from "./CouponsPage.vue?vue&type=template&id=47b06110"
import script from "./CouponsPage.vue?vue&type=script&lang=js"
export * from "./CouponsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports